import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ConstraintSpecDetailComponent } from '../../../../process/capability-spec/constraints/constraint-spec-detail/constraint-spec-detail.component'
import { ConstraintUtils } from '../../../../process/capability-spec/constraints/constraint-utils'
import { WorkStationConfiguration } from '../../configurations/work-station-configuration'

export interface IWsConfigurationDialogOptions {
  readonly config: WorkStationConfiguration
}

@Component({
  selector: 'app-ws-configuration-dialog',
  templateUrl: './ws-configuration-dialog.component.html',
  styleUrls: ['./ws-configuration-dialog.component.scss'],
  imports: [ConstraintSpecDetailComponent],
})
export class WsConfigurationDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly configuration: WorkStationConfiguration
  public readonly original: WorkStationConfiguration
  private dialogRef = inject<MatDialogRef<WsConfigurationDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IWsConfigurationDialogOptions>(MAT_DIALOG_DATA)
    this.configuration = new WorkStationConfiguration()
    this.original = data.config
    ConstraintUtils.update(this.original?.spec, this.configuration?.spec)
    ConstraintUtils.updateConf(this.original?.activeConf, this.configuration?.activeConf)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.close(this.configuration)
  }

  public close(config?: WorkStationConfiguration): void {
    this.dialogRef.close(config)
  }
}
